export const seasonReleaseDate = {
  1: new Date('2017-09-06 09:00:00 UTC'),
  2: new Date('2017-12-05 17:00:00 UTC'),
  3: new Date('2018-05-08 17:00:00 UTC'),
  4: new Date('2018-09-17 17:00:00 UTC'),
  5: new Date('2018-12-04 17:00:00 UTC'),
  6: new Date('2019-03-05 17:00:00 UTC'),
  7: new Date('2019-06-17 17:00:00 UTC'),
  8: new Date('2019-10-01 17:00:00 UTC'),
  9: new Date('2019-12-10 17:00:00 UTC'),
  10: new Date('2020-03-10 17:00:00 UTC'),
  11: new Date('2020-06-09 17:00:00 UTC'),
  12: new Date('2020-11-10 17:00:00 UTC'),
  13: new Date('2021-02-09 17:00:00 UTC'),
  14: new Date('2021-05-11 17:00:00 UTC'),
  15: new Date('2021-08-24 17:00:00 UTC'),
  16: new Date('2022-02-22 17:00:00 UTC'),
  17: new Date('2022-05-24 17:00:00 UTC'),
  18: new Date('2022-08-23 17:00:00 UTC'),
  19: new Date('2022-12-06 17:00:00 UTC'),
  20: new Date('2023-02-28 17:00:00 UTC'),
  21: new Date('2023-05-23 17:00:00 UTC'),
  22: new Date('2023-08-22 17:00:00 UTC'),
  23: new Date('2023-11-28 17:00:00 UTC'),
  24: new Date('2024-06-04 17:00:00 UTC'),
  25: new Date('2024-10-08 17:00:00 UTC'),
  26: new Date('2025-02-04 17:00:00 UTC')
}
